import { Component, Vue } from 'vue-property-decorator'
import { menuBtn } from '@/utils/menu_level2_button'
import { formatDate } from '@/utils/timeFilter'
import { getFinanceOrderById } from '@/api/financial-center'

@Component({})
export default class PaperOrderInfo extends Vue {
    orderId: number = undefined
    logShow = true
    infoData = {}
    status = ''
    activities = []

    created() {
        this.orderId = Number(this.$route.query.id)
        this.status = this.$route.query.status as string
        this.getInfoData()
    }

    menuBtn = menuBtn
    formatDate = formatDate

    async getInfoData() {
        const data: any =  await getFinanceOrderById({ id: this.orderId, isUpdatedData: '0' }) 
        this.infoData = data.financeOrder
        //    审批流程
        this.activities = data.financeOrder.messageReviewList
    }

    clickEditButton() {
        this.$router.push({
            path: 'newPaperOrder',
            query: {
                orderId: String(this.orderId)
            }
        })
    }
}
